import Service1 from '../assets/images/services/sv-1.jpg';
import Service2 from '../assets/images/services/sv-2.jpg';
import Service3 from '../assets/images/services/sv-3.jpg';
import Service4 from '../assets/images/services/sv-4.jpg';
import Service5 from '../assets/images/services/sv-5.jpg';
import Service6 from '../assets/images/services/sv-6.jpg';
import labour_out from '../assets/images/services/labour_out.png';
import recruit from '../assets/images/services/recruitm.png';
import advice from '../assets/images/services/advice.png';
import policy from '../assets/images/services/policy.png';
import training from '../assets/images/services/training.png';


export const services = [
    {
        image: Service1,
        category: "Management",
        icon: "consulting",
        title: 'labour outsourcing',
        text: 'Cost-effective solution to handle your staffing needs efficiently.',
        link: '#services-labour',
        img_src:labour_out,
        id: 1,
        desc1: `Streamline your operations with our comprehensive labour outsourcing solutions`,
        desc2: `Whether you have an in-house HR team or none at all, our effective HR support ensures your business stays compliant and efficient. 
        Our team of highly qualified professionals is available 24/7 to provide unlimited, untimed expert advice.`,
        desc3: `At Hillrock Resource Ltd, we are committed to providing comprehensive HR support that enhances 
        your business operations and drives success. Contact us today to learn more about 
        how our outsourcing services can benefit your organization.`,
        serviceList: [
            {
                title: 'Contract management solutions',
                servDesc: `Streamline your contract processes with our comprehensive management solutions, ensuring all agreements are well-documented and legally compliant.`,
            },
            {
                title: 'Employee relations',
                servDesc: `Foster a positive workplace environment with our expert employee relations services, designed to resolve conflicts, 
                improve communication, and enhance overall employee satisfaction.`,
            },
            {
                title: 'Payroll management', 
                servDesc: `Ensure timely and accurate payroll processing with our reliable management services, 
                handling everything from salary disbursement to tax compliance.`,
            },
            {
                title: 'Recruitment and Placement', 
                servDesc: `Find the right talent to fit your organization’s needs with our efficient recruitment and placement services, 
                leveraging our extensive network to match candidates with your business goals.`,
            },
            {
                title: 'Onboarding', 
                servDesc: `Facilitate a smooth transition for new hires with our structured onboarding programs, ensuring 
                they are well-integrated and ready to contribute from day one.`,
            },
            {
                title: 'Separation management', 
                servDesc: `Manage employee exits with professionalism and sensitivity through our separation management services, 
                minimizing disruptions and maintaining a positive employer brand.`,
            },
            {
                title: 'Compliance', 
                servDesc: `Stay ahead of regulatory changes and ensure your business adheres to all relevant 
                laws and regulations with our proactive compliance support.`,
            },
            {
                title: 'Health and safety', 
                servDesc: `Promote a safe and healthy work environment with our health and safety services, 
                including risk assessments, training, and policy development.`,
            },
            {
                title:`Scalable Solutions`,
                servDesc:`Our HR support is designed to grow with your business, providing scalable solutions that adapt to your changing needs.`,
            },
            {
                title:`Cost-Effective`,
                servDesc:`Reduce overhead costs and improve efficiency by outsourcing your HR functions to our expert team.`,
            },
            {
                title:`Confidential and Secure`,
                servDesc:`We prioritize the confidentiality and security of your HR data, ensuring all information is handled with the utmost care and discretion.`,
            }
        ],
    },
    {
        image: Service2,
        category: "Resources",
        icon: "controller",
        title: 'Recruitment and placement',
        text: `We identify and attract top-tier talent that aligns with your company's values and goals.`,
        link: '#recruitment-labour',
        img_src:recruit,
        id: 2,
        desc1: `Find the right talent to lead your organization to new heights.`,
        desc2: `Finding the right talent is crucial for business success. We understand your needs and connect you with candidates that align with your business goals. 
        With our extensive network, you gain access to a large pool of qualified candidates, making the hiring process seamless and efficient.`,
        desc3: `Choose Hillrock Resource Ltd for a recruitment experience that goes beyond simply filling positions. We are here to help you build a strong, capable, and cohesive team that will drive your business to new heights. 
        Contact us today to learn more about how our tailored recruitment solutions can benefit your organization.`,
        serviceList: [
            {
                title: 'Extensive Network of Qualified Candidates',
                servDesc: `With our extensive network, you gain access to a large pool of
                 highly qualified candidates across various industries and job functions.
                  Whether you are looking for entry-level employees, experienced professionals, or executive leaders,
                   we have the resources 
                and expertise to find the right talent for your organization.`
            },
            {
                title: 'Tailored Recruitment Solutions',
                servDesc: `We offer customized recruitment solutions to meet your specific needs. 
                Our team works closely with you to understand your requirements and develop a targeted strategy that 
                attracts the best candidates. From job postings and candidate screening to interviews and onboarding, 
                we handle every aspect of the recruitment process with precision and care.`,
            },
            {
                title: 'Streamlined Hiring Process',
                servDesc: `Our streamlined hiring process ensures that you save time and resources while finding the best candidates. We use advanced tools and methodologies to identify top talent quickly and efficiently. 
                Our rigorous screening process ensures that only the most suitable candidates are presented to you, reducing the time-to-hire and enhancing the quality of your hires.`,
            },
            {
                title: 'Expert Guidance and Support',
                servDesc: `At Hillrock Resource Ltd, we provide expert guidance and support throughout the recruitment process. Our experienced consultants are available to assist you with everything from job description creation and market analysis to salary benchmarking and offer negotiation. 
                We are dedicated to helping you make informed hiring decisions that drive your business forward.`
            },
            {
                title: 'Long-term Partnership',
                servDesc: `We believe in building long-term partnerships with our clients. Our goal is to be more than just a recruitment agency; we aim to be a trusted partner in your business success. By understanding your long-term vision and strategic goals, 
                we can provide ongoing support and talent solutions that help you achieve sustained growth and success.`,
            },
            {
                title: 'Commitment to Quality and Excellence',
                servDesc: `Quality and excellence are at the core of our recruitment services. We are committed to delivering the highest standards of service and ensuring that every candidate we present is thoroughly vetted and aligned with your expectations. 
                Our dedication to excellence has earned us a reputation as a reliable and effective recruitment partner.`,
            },
        ],
    },
    {
        image: Service4,
        category: "Program",
        icon: "job",
        title: 'Expert HR advisory & solutions',
        text: 'Navigate the complexities of HR management with our expert advisory services',
        link: '#advisory-labour',
        img_src:advice,
        id: 3,
        desc1: `Enhance your HR practices with our expert guidance on procedures, manuals, employee relations, and surveys.`,
        desc2: ``,
        desc3: `Hillrock Resource Advisory (HRA), comprising of a pool of sector experts will help your organization navigate complex HR challenges and
         provide tailored solutions based on the organization’s unique needs. Our consultants will walk with you making informed HR and Business decisions 
         while creating compliant, productive, 
        and safe workplaces supported by robust legal frameworks and best-practice HR management`,
        serviceList: [
            {
                title: 'HR Policies and Frameworks', servDesc: '',
            },
            {
                title: 'Change Management Initiatives', servDesc: '',
            },
            {
                title: '  HR Audits', servDesc: '',
            },
            {
                title: 'Performance Management Process Implementation', servDesc: '',
            },
            {
                title: ' Employment Regulation Guidance', servDesc: '',
            },
            {
                title: ' Employee Counselling Services', servDesc: '',
            },
            {
                title: 'Baseline Surveys', servDesc: '',
            },
            {
                title: 'Training and Development', servDesc: '',
            },
            {
                title: ' Risk Management and Compliance', servDesc: '',
            },
            {
                title: ' Payroll Administration', servDesc: '',
            },


        ],
    },
    {
        image: Service3,
        category: "Solution",
        icon: "policy",
        title: "Staffing Solution",
        text: "Lorem ipsum dolor sit amet, consectetur notted adipisicing elit sed do eiusmod",
        link: "#service-hydro",
        img_src:policy,
        id: 4,
        desc1: ``,
        desc2: ``,
        desc3: '',
        serviceList: [
            {
                title: '   Contract management solutions', servDesc: '',
            },
            {
                title: 'Employee relations', servDesc: '',
            },
            {
                title: 'Payroll management', servDesc: '',
            },
            {
                title: 'Recruitment and Placement', servDesc: '',
            },
            {
                title: 'Onboarding', servDesc: '',
            },
            {
                title: 'Separation management', servDesc: '',
            },
            {
                title: 'Compliance', servDesc: '',
            },
            {
                title: 'Health and safety', servDesc: '',
            },

        ],
    },
    {
        image: Service5,
        category: "Training",
        icon: "teaching",
        title: "Leadership Training",
        text: "Invest in your team's growth with our customized training programs.",
        link: "#service-training",
        img_src:training,
        id: 5,
        desc1: `Invest in your team's growth with our customized training programs.`,
        desc2: ``,
        desc3: '',
        serviceList: [

        ],
    },
    {
        image: Service6,
        category: "Management",
        icon: "employment",
        title: "Staff Management",
        text: "Lorem ipsum dolor sit amet, consectetur notted adipisicing elit sed do eiusmod",
        link: "#service-management",
        img_src:training,
        id: 6,
        desc1: ``,
        desc2: ``,
        desc3: '',
        serviceList: [
        ],
    }
];